export default __webpack_public_path__ + "static/media/3DOLOGO.cdb6b56c.png";